import {
    CONTRACT_TYPE_FOREST_OPERATION,
    CONTRACT_TYPE_SUPPLY_WOOD
} from "~/constants/contracts";

export const NEW_QUOTE_OPTIONS = [
    {
        key: 'forestoperation',
        value: CONTRACT_TYPE_FOREST_OPERATION,
        text: 'QUOTE.TYPE_FOREST_OPERATION',
        subText: 'QUOTE.TYPE_FOREST_OPERATION_DESC',
        icon: 'spot/large/felling'
    }, {
        key: 'supplywood',
        value: CONTRACT_TYPE_SUPPLY_WOOD,
        text: 'QUOTE.TYPE_SUPPLY_WOOD',
        subText: 'QUOTE.TYPE_SUPPLY_WOOD_DESC',
        icon: 'spot/large/mill'
    }
]

export const QUOTE_REJECTION_REASON_TOO_LOW_ECONOMIC_VALUE = 735300000
export const QUOTE_REJECTION_REASON_WRONG_TIME_FOR_OPERATION = 735300001
export const QUOTE_REJECTION_REASON_NO_REASON_GIVEN = 735300002
export const QUOTE_REJECTION_REASON_OTHER = 735300003
export const QUOTE_REJECTION_DESCRIPTION_MAX_LENGTH = 200

export const QUOTE_REJECTION_REASONS = [
    {key: 'tooLowEconomicValue', value: QUOTE_REJECTION_REASON_TOO_LOW_ECONOMIC_VALUE, text: 'QUOTE.REJECTION_REASON_TOO_LOW_ECONOMIC_VALUE'},
    {key: 'wrongTimeForOperation', value: QUOTE_REJECTION_REASON_WRONG_TIME_FOR_OPERATION, text: 'QUOTE.REJECTION_REASON_WRONG_TIME_FOR_OPERATION'},
    {key: 'noReasonGiven', value: QUOTE_REJECTION_REASON_NO_REASON_GIVEN, text: 'QUOTE.REJECTION_REASON_NO_REASON_GIVEN'},
    {key: 'other', value: QUOTE_REJECTION_REASON_OTHER, text: 'QUOTE.REJECTION_REASON_OTHER'},
]

export const QUOTE_TYPES = [
    {
        Id: CONTRACT_TYPE_FOREST_OPERATION,
        Name: 'QUOTE.TYPE_FOREST_OPERATION',
        NewLabel: 'QUOTE.NEW_TYPE_FOREST_OPERATION'
    },
    {
        Id: CONTRACT_TYPE_SUPPLY_WOOD,
        Name: 'QUOTE.TYPE_SUPPLY_WOOD',
        NewLabel: 'QUOTE.NEW_TYPE_SUPPLY_WOOD'
    }
]
